import { create } from "zustand"

/**
 * Auth Zustand store — lightweight auth-related UI state.
 *
 * `initialSyncActive` is true ONLY while the InitialSyncLoader overlay is
 * visible — i.e. when a user logs in on a NEW DEVICE and data is being
 * downloaded. It is NEVER set during page refresh or token refresh.
 *
 * Consumers: useDeviceSync, usePushSync (delay API calls until sync completes).
 */

interface AuthState {
  /** True while InitialSyncLoader is visible (new device, downloading data) */
  initialSyncActive: boolean

  // ── Actions ──
  setInitialSyncActive: (active: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  initialSyncActive: false,

  setInitialSyncActive: (active) => set({ initialSyncActive: active }),
}))
